import { render, staticRenderFns } from "./EmptyTeamsList.vue?vue&type=template&id=72a59ad2&scoped=true&"
var script = {}
import style0 from "./EmptyTeamsList.vue?vue&type=style&index=0&id=72a59ad2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a59ad2",
  null
  
)

export default component.exports